import React from "react";

// import { generate as randStr } from "randomstring"

import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
import classnames from "classnames";
import { propOr } from "ramda"

import { randStr } from "root/js/utils";

import styles from "./index.module.scss";

const Select_ = props => {
  const { MenuProps, label, disabled, error, helperText, className, classes = {}, ...rest } = props;

  const id = randStr({
    length: 12,
    charset: "alphabetic"
  });

  return (
    <FormControl
      variant="outlined"
      className={classnames(styles.root, className, classes.root)}
      fullWidth>
      <InputLabel
        id={id}
        classes={{
          root: styles.labelRoot,
          focused: styles.labelFocused,
          shrink: styles.labelShrink,
          disabled: styles.disabled
        }}
        hidden={true}
        disabled={disabled}>
        {label}
      </InputLabel>
      <Select
        labelId={id}
        displayEmpty
        error={error}
        classes={{
          root: classnames(
            styles.selectRoot_main,
            classes.selectRoot,
            props.value && props.value.length > 0 ? styles.selectRootFilled : null
          ),
          disabled: styles.disabled
        }}
        disabled={disabled}
        MenuProps={Object.assign(
          {
            classes: {
              paper: styles.menuPaper,
            },
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "center"
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "center"
            },
            getContentAnchorEl: null
          },
          MenuProps
        )}
        input={
          <OutlinedInput
            label={label}
            classes={{
              root: classnames(styles.InputRoot, classes.InputRoot),
              notchedOutline: styles.notchedOutline,
              focused: classnames(styles.focused, classes.focused),
              disabled: styles.disabled,
              error: styles.error
            }}
            disabled={disabled}
          />
        }
        {...rest}
      />
      {helperText && (
        <FormHelperText error={error} classes={{ error: styles.helperTextError }}>
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default Select_;
